/**
 * Adzuki
 * broadcast.js
 */

(function Broadcast($, Adzuki)
{
	"use strict";

	var Broadcast = function Broadcast() {
		this.broadcastEventHandler = function broadcastEventHandler(eventData) {
			console.log(eventData);

			switch (eventData.eventType) {
				case 'broadcast_available':
					showBroadcast(eventData);
					break;
				default:
					console.log('Unknown event type:', eventData.eventType);
					break;
			}
		};
	};

	$(document).ready(function documentReady()
	{
		var broadcastInstance = new Broadcast(); // eslint-disable-line no-unused-vars
	});

	// Show the broadcast
	function showBroadcast(eventData) {
		const title           = eventData.title;
		const happening       = eventData.happening;
		const broadcastClosed = document.cookie.split(';').some(item => item.trim().startsWith('broadcastClosed='));
		
		if (broadcastClosed) {
			$('.broadcast-container').slideUp();
			$('.broadcast-indicator').removeClass('flashing');
		} else {
			$('.broadcast-container').slideDown();
			$('.broadcast-title-text').text(title);
			$('.broadcast-happening').text(happening);
			
			// Only add flashing class if happening is 'now'
			if (happening.toLowerCase() === 'now') {
				$('.broadcast-indicator').addClass('flashing');
			} else {
				$('.broadcast-indicator').removeClass('flashing');
			}
			
			// Smooth scroll to top of page
			$('html, body').animate({
				scrollTop: 0
			}, 800);
		}

		// Don't show broadcast if we're already on a broadcast page
		if (window.location.href.indexOf('/broadcast') !== -1 || window.location.href.indexOf('/login') !== -1) {
			$('.broadcast-container').slideUp();
			$('.broadcast-indicator').removeClass('flashing');
			return;
		}
	}

	// Set the closed cookie
	function setClosedCookie() {
		var cookie_domain = '.cruiseplannersnet.com';

		if (Adzuki.dev) {
			// on dev, use dev domain
			cookie_domain = '.adzuki.com';
		}

		Cookies.set('broadcastClosed', 'true', {domain: cookie_domain});
	}

	// Add click event listener to the close button
	$('.broadcast-close-btn').on('click', function _closeBroadcast() {
		// Hide the broadcast element
		$('.broadcast-container').hide();

		// Set cookie 
		setClosedCookie();
	}); 

	// Add CSS for flashing animation
	const flashingStyle = `
		@keyframes flash {
			0% { opacity: 1; }
			50% { opacity: 0.3; }
			100% { opacity: 1; }
		}
		.flashing {
			animation: flash 1s infinite;
		}
	`;
	$('<style>').text(flashingStyle).appendTo('head');

	Adzuki.Broadcast = new Broadcast();
}(jQuery, window.Adzuki || {}));
